import React, { FC, useCallback, useState } from 'react';
import { Button } from 'src/common';
import { useTranslation } from 'react-i18next';
import { AdvancedSettingsModal } from './AdvancedSettingsModal';
import { IKeyword } from 'src/models/matchingProfiles/types';

interface IProps {
  mpId: string;
  mpName: string;
  keywords: IKeyword[];
  disabled?: boolean;
}

export const AdvancedSettings: FC<IProps> = props => {
  const { disabled, mpId, mpName, keywords } = props;
  const { t } = useTranslation();

  const [modalVisible, setModalVisible] = useState(false);

  const onShowModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  const onHideModal = useCallback(() => {
    setModalVisible(false);
  }, []);
  return (
    <>
      <Button onClick={onShowModal} type={'primary'}>
        {t('Tenders.advancedSettings')}
      </Button>
      {modalVisible && (
        <AdvancedSettingsModal
          onClose={onHideModal}
          disabled={disabled}
          mpId={mpId}
          mpName={mpName}
          keywords={keywords}
        />
      )}
    </>
  );
};

export default AdvancedSettings;
